import React from "react";
import { formatCurrencyUsd } from "../../shared/utils/financeDisplay";
import MetricStatCard from "../MetricStatCard";

/**
 * Summary for Stock Management: stock count, total equity, upcoming earnings (clickable filter).
 */
export default function StockSummaryStatCards({
  stockCount,
  totalInvestment,
  showTotalInvestment = true,
  upcomingEarningsCount = 0,
  upcomingEarningsActive = false,
  onUpcomingEarningsClick,
  recentBuyCount = 0,
  recentBuyActive = false,
  onRecentBuyClick,
  currentHoldingCount = 0,
  currentHoldingActive = false,
  onCurrentHoldingClick,
  style,
  className,
}) {
  const count = Number(stockCount) || 0;
  const upcoming = Number(upcomingEarningsCount) || 0;
  const recentBuy = Number(recentBuyCount) || 0;
  const currentHolding = Number(currentHoldingCount) || 0;
  return (
    <div
      className={`cards-wrapper cards-wrapper--sm cards-wrapper--stock-summary${className ? ` ${className}` : ""}`}
      style={style}
      role="region"
      aria-label="Stock summary"
    >
      <MetricStatCard
        label="Total Stocks"
        value={count.toLocaleString(undefined, { maximumFractionDigits: 0 })}
        valueStyle={{ color: "#2563eb" }}
      />
      {showTotalInvestment ? (
        <MetricStatCard
          label="Total Investment"
          value={formatCurrencyUsd(totalInvestment)}
          valueStyle={{ color: "#16a34a" }}
        />
      ) : null}
      {onCurrentHoldingClick ? (
        <MetricStatCard
          label="Current Holding"
          value={currentHolding.toLocaleString(undefined, { maximumFractionDigits: 0 })}
          valueStyle={{ color: "#0891b2" }}
          onClick={onCurrentHoldingClick}
          active={currentHoldingActive}
          title={
            currentHoldingActive
              ? "Filter active — click to clear"
              : "Click to filter list to equity greater than zero"
          }
          regionAriaLabel={`Current holdings with equity greater than zero: ${currentHolding}. ${
            currentHoldingActive ? "Filter active, click to clear." : "Click to filter list."
          }`}
        />
      ) : null}
      <MetricStatCard
        label="Upcoming Earnings (30 days)"
        value={upcoming.toLocaleString(undefined, { maximumFractionDigits: 0 })}
        valueStyle={{ color: "#d97706" }}
        onClick={onUpcomingEarningsClick}
        active={upcomingEarningsActive}
        title={
          onUpcomingEarningsClick
            ? upcomingEarningsActive
              ? "Filter active — click to clear"
              : "Click to filter list by earnings date"
            : undefined
        }
        regionAriaLabel={`Upcoming earnings in 30 days: ${upcoming}. ${
          upcomingEarningsActive ? "Filter active, click to clear." : "Click to filter list."
        }`}
      />
      {onRecentBuyClick ? (
        <MetricStatCard
          label="Recent Buy (30 days)"
          value={recentBuy.toLocaleString(undefined, { maximumFractionDigits: 0 })}
          valueStyle={{ color: "#7c3aed" }}
          onClick={onRecentBuyClick}
          active={recentBuyActive}
          title={
            recentBuyActive
              ? "Filter active — click to clear"
              : "Click to filter list by trade date"
          }
          regionAriaLabel={`Recent buy in 30 days: ${recentBuy}. ${
            recentBuyActive ? "Filter active, click to clear." : "Click to filter list."
          }`}
        />
      ) : null}
    </div>
  );
}
